import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { useMutation } from "@tanstack/react-query";

const updateMMobileLocators = async ({ strategy, value, testCaseId, teststepid }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateFindAndAssign&companyid=${user.companyid}&testCaseId=${testCaseId}&teststepid=${teststepid}`,
    {
      params: {
        strategy: strategy,
        selector: value,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  return response.data;
};

const useUpdateMobileLocators = (options) => {
  return useMutation({
    mutationFn: updateMMobileLocators,
    ...options,
  });
};
export default useUpdateMobileLocators;
